import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import NewButton from '../../common/components/NewButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, ...rest }) => {
	const formatUsed = (used, row) => {
		if (used && row.typeId == 5 && row.allowPartialUse) {
			return `${ui.formatBoolean(used)} (${row.usedAmount})`;
		}
		else {
			return ui.formatBoolean(used);
		}
	}

	const columns = [
		{
			header: t('Discount_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('Discount_Center'),
			accessor: item => item.center && item.center.name,
			sortable: true
		},
		{
			header: t('Discount_Value'),
			accessor: item => `${item.value}${item.isPercentage ? '%' : ''}`,
			sortable: true,
			sortKey: 'value'
		},
		{
			header: t('Discount_Type'),
			accessor: 'type',
			cell: (type) => t(`DiscountType_${type.name}`), 
			sortable: true,
			sortKey: 'typeName'
		},
		{
			header: t('Discount_PromoCode'),
			accessor: 'promoCode',
			sortable: true,
			sortKey: 'promoCode'
		},
		{
			header: t('Discount_Term'),
			accessor: 'term.name',
			sortable: true
		},
		{
			header: t('Discount_Grade'),
			accessor: 'grade.name',
			sortable: true
		},
		{
			header: t('Discount_Parent'),
			accessor: 'parent',
			cell: (parent) => parent && parent.name,
			sortable: true
		},
		{
			header: t('Discount_IsActive'),
			accessor: 'isActive',
			sortable: true,
			cell: (isActive) => (ui.formatBoolean(isActive))
		},
		{
			header: t('Discount_Used'),
			accessor: 'used',
			sortable: false,
			cell: (used, row) => formatUsed(used, row)
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id,row) => (<Link to={`/discounts/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={row.isReadonly ? faEye : faEdit} /> {t(row.isReadonly ? 'Common_View' : 'Common_Edit')}</Link>)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/discounts/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);